export default __webpack_public_path__ + "static/media/urbex.14ce394f.jpg";